
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M8.1 13.34L10.93 10.51L4.74 4.33002C4.26 3.85002 3.43 3.98002 3.13 4.60002C2.42 6.09002 2.68 7.92002 3.91 9.16002L8.1 13.34ZM14.88 11.53C16.41 12.24 18.56 11.74 20.15 10.15C22.06 8.24002 22.43 5.50002 20.96 4.03002C19.5 2.57002 16.76 2.93002 14.84 4.84002C13.25 6.43002 12.75 8.58002 13.46 10.11L4.4 19.17C4.01 19.56 4.01 20.19 4.4 20.58C4.79 20.97 5.42 20.97 5.81 20.58L12 14.41L18.18 20.59C18.57 20.98 19.2 20.98 19.59 20.59C19.98 20.2 19.98 19.57 19.59 19.18L13.41 13L14.88 11.53Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-restaurant-menu`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRestaurantMenu

    ```js
    <b-new-b-icon-restaurant-menu />
    ```
</docs>


